module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "Abb"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_vm._v("List of Figures")])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("1.")]), _vm._v(" GS(R) Reports 1936–1939")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("2.")]), _vm._v(" Summary list of MI(R) missions September 1939–October 1940")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("3.")]), _vm._v(" War Establishment of MI(R), August 1940")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("4.")]), _vm._v(" Extract from substitution codes in connection with the projected Norwegian campaign, February 1940")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("5.")]), _vm._v(" Members of the Polish mission, August–October 1939")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("6.")]), _vm._v(" Outline map of the towns featured in the 1940 Norwegian campaign")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("7.")]), _vm._v(" Parent divisions and commanders of the Independent Companies")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("8.")]), _vm._v(" Map showing the line of retreat from Mo i Rana to Bodo, Norway, in May 1940")]), _vm._v(" "), _c('p', {
    staticClass: "list_fig"
  }, [_c('span', {
    staticClass: "list_fighang"
  }, [_vm._v("9.")]), _vm._v(" Outline map of the Middle East and African operations of MI(R)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb29c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/List_of_Figures.vue
// module id = 72
// module chunks = 0